import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { Header } from './infrastructure/components/Header/Header';
import { Footer } from './infrastructure/components/Layout/Footer';
import UserManager, { ACCESS_PERMISSION } from './application/common/usermanagement';
import { Login } from './presentation/components/Authentication/Login/Login';
import { routes } from './routes';
import { Banner } from './infrastructure/components/Header/Banner';

export const App = (): JSX.Element => {
  if (!UserManager.checkToken()) {
    return (
      <BrowserRouter>
        <Container as="header" className="bg-grey shadow-lg">
        <Banner />
      </Container>
        <Container as="main" className="py-3" id="loginView">
          <Login/>
        </Container>
        <Footer />
      </BrowserRouter>
    ); 
  }
  const routeLinks = routes.map((route) => {
    if (!route.isDropdown)
      return (
        <Route
          key={route.path}
          exact={route?.exact}
          path={route.path}
          component={route.component}
        />
      );
    else
      return route.children?.map((dropdownItem) => (
        <Route
          key={dropdownItem.path}
          path={dropdownItem.path}
          component={dropdownItem.component}
        />
      ));
  });

  return (
    <BrowserRouter>
      <Header />
      <Container as="main" className="py-3">
        <Switch>{routeLinks}</Switch>
      </Container>
      <Footer />
    </BrowserRouter>
  );
};
